<div class="page-purchases">

    <h2 class="section-title">Mis entradas</h2>

    <!-- ===== TU PRÓXIMO PLAN ===== -->
    <!-- Con más de un plan hoy el banner los va pasando: puntitos debajo, y
         el punto activo se va llenando hasta que toca el siguiente. Se para
         con el ratón encima, con el foco dentro o con el calendario abierto.
         El *ngFor de un solo elemento es para que cada plan sea un nodo
         distinto y la animación tenga uno que sale y otro que entra. -->
    <div class="next-plan-wrap" *ngIf="nextPlan"
        [class.en-pausa]="carruselEnPausa"
        [style.--segundos-plan]="segundosPorPlan + 's'">
        <article class="next-plan" [class.carrusel]="nextPlans.length > 1"
            [@cambioPlan]="animacionPlan"
            [attr.aria-roledescription]="nextPlans.length > 1 ? 'carrusel' : null"
            (pointerenter)="pausaPorRaton($event, true)"
            (pointerleave)="pausaPorRaton($event, false)"
            (focusin)="pausaPorFoco(true)"
            (focusout)="pausaPorFoco(false)"
            (pointerdown)="empiezaDeslizarPlan($event)"
            (pointerup)="sueltaDeslizarPlan($event)"
            (pointercancel)="sueltaDeslizarPlan($event)">
            <ng-container *ngFor="let plan of [nextPlan]; trackBy: trackByKey">
                <div class="next-plan-body">
                    <div class="next-plan-tags">
                        <!-- El día del evento la etiqueta pasa a ser la misma pill verde
                             de "¡Es hoy!" que llevan las tarjetas de la web, y sobra
                             el "Hoy" de la cuenta atrás. -->
                        <span class="tag-hoy pill-state tag-today" *ngIf="plan.today; else etiquetaNormal">
                            <i class="fal fa-bell"></i>
                            ¡Es hoy!
                        </span>
                        <ng-template #etiquetaNormal>
                            <span class="tag">
                                <i class="fa-light fa-clock"></i>
                                Tu próximo plan
                            </span>
                            <span class="countdown" *ngIf="plan.countdown">{{ plan.countdown }}</span>
                        </ng-template>
                    </div>

                    <h3 class="next-plan-title">{{ plan.eventTitle }}</h3>

                    <div class="next-plan-meta">
                        <span><i class="fa-light fa-calendar"></i>{{ plan.dateLong }}</span>
                        <!-- El propio sitio es el enlace a Google Maps: es donde
                             uno mira para saber a dónde ir. Un <a> de verdad, para
                             que en el móvil se pueda abrir en la app de mapas o
                             copiar manteniendo pulsado. -->
                        <a class="lugar-mapa" *ngIf="mapsUrl(plan) as url; else lugarSinMapa"
                            [href]="url" target="_blank" rel="noopener" title="Ver en Google Maps">
                            <i class="fa-light fa-location-dot"></i>
                            <span class="lugar-nombre">{{ plan.spaceName || plan.address }}</span>
                            <i class="fa-light fa-arrow-up-right-from-square lugar-externo"></i>
                        </a>
                        <ng-template #lugarSinMapa>
                            <span *ngIf="plan.spaceName"><i class="fa-light fa-location-dot"></i>{{ plan.spaceName }}</span>
                        </ng-template>
                        <!-- Las devueltas no cuentan. -->
                        <span>
                            <i class="fa-light fa-ticket"></i>
                            {{ entradasVigentes(plan) }} {{ entradasVigentes(plan) === 1 ? 'entrada' : 'entradas' }}<ng-container *ngIf="plan.isSeasonPassOrder"> de tu abono</ng-container>
                        </span>
                    </div>

                    <!-- De qué pedido: el PDF de "Descargar entradas del pedido" es
                         de ese pedido entero, y si trae más eventos se dice.
                         `&ngsp;` es el espacio que Angular no se come entre
                         elementos; cada trozo va sin partir y baja entero. -->
                    <p class="next-plan-tickets next-plan-order" *ngIf="!plan.isSeasonPassOrder">
                        <i class="fa-light fa-receipt"></i>
                        <span>
                            <span class="sin-partir">Pedido #{{ plan.orderNumber }}<ng-container *ngIf="plan.eventsInOrder > 1"> ({{ plan.eventsInOrder }} eventos)</ng-container></span>&ngsp;
                            <span class="sin-partir" *ngIf="plan.purchasedOn">· Comprado el {{ plan.purchasedOn }}</span>
                        </span>
                    </p>

                    <!-- En móvil: "Ver entradas" y "Calendario" a medias arriba, y la
                         descarga debajo a todo el ancho para que quepa su texto
                         entero (ver el scss). -->
                    <div class="next-plan-actions">
                        <button type="button" class="btn-primary" (click)="openTickets(plan)">
                            <i class="fa-light fa-qrcode"></i>
                            Ver entradas
                        </button>
                        <!-- El PDF es del PEDIDO entero (lo genera el TPV), no solo de
                             este evento, y el texto lo dice entero: "Descargar
                             pedido" no dejaba claro que fueran las entradas. Las de
                             abono no tienen descarga. -->
                        <button type="button" class="btn-ghost btn-descargar" *ngIf="!plan.isSeasonPassOrder" (click)="downloadTickets(plan)"
                            [title]="'Descargar en PDF todas las entradas del pedido #' + plan.orderNumber">
                            <i class="fa-light fa-arrow-down-to-line"></i>
                            Descargar entradas del pedido
                        </button>
                        <!-- Google y Outlook abren su web con el evento relleno; el .ics
                             lo sirve la API y en iPhone va el primero, porque abre la
                             hoja nativa (ver calendar-links.util). -->
                        <div class="calendar-menu">
                            <button type="button" class="btn-ghost" (click)="toggleCalendar()">
                                <i class="fa-light fa-calendar-plus"></i>
                                <span class="txt-largo">Añadir al calendario</span>
                                <!-- En móvil, a medio ancho, el largo se partía en dos líneas. -->
                                <span class="txt-corto">Calendario</span>
                                <i class="fa-light" [ngClass]="showCalendar ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </button>

                            <div class="calendar-options" *ngIf="showCalendar">
                                <ng-container *ngIf="plataforma === 'ios' && !sinSafari" [ngTemplateOutlet]="nativo"></ng-container>
                                <button type="button" (click)="addToGoogleCalendar(plan)">
                                    <i class="fa-brands fa-google"></i>
                                    Google Calendar
                                </button>
                                <button type="button" (click)="addToOutlookCalendar(plan)">
                                    <i class="fa-brands fa-microsoft"></i>
                                    Outlook
                                </button>
                                <ng-container *ngIf="plataforma !== 'ios' || sinSafari" [ngTemplateOutlet]="nativo"></ng-container>
                            </div>

                            <ng-template #nativo>
                                <a *ngIf="!sinSafari && icsHref(plan) as href" [href]="href" (click)="cerrarCalendarioTrasNavegar()">
                                    <i [ngClass]="plataforma === 'ios' || plataforma === 'mac' ? 'fa-brands fa-apple' : 'fa-light fa-calendar'"></i>
                                    {{ nativeCalendarLabel }}
                                </a>
                                <!-- En iPhone, fuera de Safari, el .ics no llega al Calendario: se
                                     avisa en vez de dejar un enlace que no hace nada. -->
                                <p class="m-0 calendar-aviso" *ngIf="sinSafari">
                                    <i class="fa-brands fa-apple"></i>
                                    <span>Para el calendario del iPhone, abre esta página en Safari</span>
                                </p>
                            </ng-template>
                        </div>
                    </div>
                </div>

                <div class="next-plan-image">
                    <img *ngIf="plan.eventImage" [src]="urlEvents + plan.eventImage" [alt]="plan.eventTitle">
                    <i class="fa-light fa-image" *ngIf="!plan.eventImage"></i>
                </div>
            </ng-container>
        </article>

        <div class="next-plan-dots" *ngIf="nextPlans.length > 1" role="group" aria-label="Tus planes de hoy">
            <button type="button" *ngFor="let plan of nextPlans; let i = index"
                class="dot" [class.activo]="i === nextPlanIndex"
                [attr.aria-label]="'Plan ' + (i + 1) + ' de ' + nextPlans.length + ': ' + plan.eventTitle"
                [attr.aria-current]="i === nextPlanIndex ? 'true' : null"
                (click)="irAPlan(i)">
                <span class="dot-progreso" *ngIf="i === nextPlanIndex" (animationend)="siguientePlan()"></span>
            </button>
        </div>
    </div>

    <!-- ===== PESTAÑAS, BUSCADOR Y FILTROS ===== -->
    <div class="toolbar">
        <div class="tabs">
            <button type="button"
                    [attr.aria-pressed]="scope === 'upcoming'"
                    [class.active]="scope === 'upcoming'"
                    (click)="setScope('upcoming')">
                <span class="tab-text">
                    Próximas
                    <span class="tab-count">{{ counts.upcoming || 0 }}</span>
                </span>
            </button>
            <button type="button"
                    [attr.aria-pressed]="scope === 'past'"
                    [class.active]="scope === 'past'"
                    (click)="setScope('past')">
                <span class="tab-text">
                    Pasadas
                    <span class="tab-count">{{ counts.past || 0 }}</span>
                </span>
            </button>
        </div>

        <div class="toolbar-spacer"></div>

        <div class="search-box">
            <i class="fa-light fa-magnifying-glass"></i>
            <input type="search"
                   aria-label="Buscar en mis entradas"
                   placeholder="Buscar evento o nº de pedido"
                   [ngModel]="search"
                   (ngModelChange)="onSearch($event)">
        </div>

        <!-- El panel cuelga del propio botón, como un desplegable: a todo el
             ancho de la lista eran dos filas de inputs enormes para cuatro
             fechas. -->
        <div class="filters-anchor">
            <button type="button" class="btn-filters"
                    [class.has-filters]="activeFiltersCount > 0"
                    [attr.aria-expanded]="showFilters"
                    (click)="toggleFilters()">
                <i class="fa-light fa-sliders"></i>
                Filtros
                <span class="filters-count" *ngIf="activeFiltersCount > 0">{{ activeFiltersCount }}</span>
            </button>

            <!-- ===== PANEL DE FILTROS ===== -->
            <div class="filters-panel" *ngIf="showFilters" role="dialog" aria-label="Filtros">
                <div class="filters-header">
                    <h3 class="m-0">Filtros</h3>
                    <button type="button" class="btn-close" aria-label="Cerrar filtros" (click)="toggleFilters()">
                        <i class="fa-light fa-xmark"></i>
                    </button>
                </div>

                <!-- Un solo campo por rango: se abre el calendario, se pincha
                     el primer día y el último, y queda "desde – hasta". Cada
                     extremo sigue siendo opcional. -->
                <div class="filters-group">
                    <p class="filters-label">Fecha del evento</p>
                    <div class="date-range" (click)="pickerEvento.open()">
                        <i class="fa-light fa-calendar"></i>
                        <mat-date-range-input [rangePicker]="pickerEvento" class="date-range-input">
                            <input matStartDate placeholder="Desde" aria-label="Fecha del evento, desde"
                                   [(ngModel)]="draftFilters.eventFrom">
                            <input matEndDate placeholder="Hasta" aria-label="Fecha del evento, hasta"
                                   [(ngModel)]="draftFilters.eventTo">
                        </mat-date-range-input>
                        <button type="button" class="date-clear"
                                *ngIf="draftFilters.eventFrom || draftFilters.eventTo"
                                aria-label="Borrar las fechas del evento"
                                (click)="$event.stopPropagation(); draftFilters.eventFrom = null; draftFilters.eventTo = null">
                            <i class="fa-light fa-xmark"></i>
                        </button>
                        <mat-date-range-picker #pickerEvento panelClass="citylok-range-picker"></mat-date-range-picker>
                    </div>
                </div>

                <div class="filters-group">
                    <p class="filters-label">Fecha de compra</p>
                    <div class="date-range" (click)="pickerCompra.open()">
                        <i class="fa-light fa-calendar"></i>
                        <mat-date-range-input [rangePicker]="pickerCompra" class="date-range-input">
                            <input matStartDate placeholder="Desde" aria-label="Fecha de compra, desde"
                                   [(ngModel)]="draftFilters.boughtFrom">
                            <input matEndDate placeholder="Hasta" aria-label="Fecha de compra, hasta"
                                   [(ngModel)]="draftFilters.boughtTo">
                        </mat-date-range-input>
                        <button type="button" class="date-clear"
                                *ngIf="draftFilters.boughtFrom || draftFilters.boughtTo"
                                aria-label="Borrar las fechas de compra"
                                (click)="$event.stopPropagation(); draftFilters.boughtFrom = null; draftFilters.boughtTo = null">
                            <i class="fa-light fa-xmark"></i>
                        </button>
                        <mat-date-range-picker #pickerCompra panelClass="citylok-range-picker"></mat-date-range-picker>
                    </div>
                </div>

                <div class="filters-group">
                    <p class="filters-label">Estado</p>
                    <div class="filters-chips">
                        <button type="button" [class.active]="draftFilters.refund === 'all'" (click)="draftFilters.refund = 'all'">Todas</button>
                        <button type="button" [class.active]="draftFilters.refund === 'without'" (click)="draftFilters.refund = 'without'">Sin devolución</button>
                        <button type="button" [class.active]="draftFilters.refund === 'only'" (click)="draftFilters.refund = 'only'">Devueltas</button>
                    </div>
                </div>

                <div class="filters-footer">
                    <button type="button" class="btn-link" (click)="clearFilters()">Quitar filtros</button>
                    <button type="button" class="btn-apply" (click)="applyFilters()">Aplicar</button>
                </div>
            </div>
        </div>
    </div>

    <!-- ===== FILTROS ACTIVOS =====
         Lo que está filtrando la lista, a la vista y quitable de uno en uno.
         Sin esto, con el panel cerrado solo quedaba el numerito del botón y
         no se sabía por qué faltaban entradas. -->
    <div class="active-filters" *ngIf="filterChips.length">
        <span class="filter-chip" *ngFor="let chip of filterChips">
            {{ chip.label }}
            <button type="button" [attr.aria-label]="'Quitar el filtro: ' + chip.label" (click)="removeFilter(chip.key)">
                <i class="fa-light fa-xmark"></i>
            </button>
        </span>
        <button type="button" class="btn-link" (click)="clearFilters()">Quitar filtros</button>
    </div>

    <!-- ===== LISTA ===== -->
    <div class="tickets-list" #containerEvents>

        <article class="ticket-row" *ngFor="let row of rows; trackBy: trackByKey" [class.refunded]="row.refunded">

            <div class="row-image">
                <img *ngIf="row.eventImage" [src]="urlEvents + row.eventImage" [alt]="row.eventTitle">
                <i class="fa-light fa-image" *ngIf="!row.eventImage"></i>
            </div>

            <div class="row-info">
                <p class="row-title m-0">{{ row.eventTitle }}</p>
                <div class="row-meta">
                    <span *ngIf="row.dateShort"><i class="fa-light fa-calendar"></i>{{ row.dateShort }}</span>
                    <span *ngIf="row.spaceName"><i class="fa-light fa-location-dot"></i>{{ row.spaceName }}</span>
                </div>
                <p class="row-order row-order-dentro m-0">
                    <ng-container *ngIf="!row.isSeasonPassOrder">Pedido #{{ row.orderNumber }} · </ng-container>
                    <ng-container *ngIf="row.isSeasonPassOrder">Entradas de tu abono · </ng-container>
                    Comprado el {{ row.purchasedOn }}
                </p>
            </div>

            <!-- La misma línea del pedido, pero a todo el ancho y debajo del
                 cartel, y una divisoria antes del importe. Solo en la fila en
                 dos líneas (menos de 1200px); en escritorio va dentro del
                 bloque de texto, la de arriba. -->
            <p class="row-order row-order-fuera m-0">
                <ng-container *ngIf="!row.isSeasonPassOrder">Pedido #{{ row.orderNumber }} · </ng-container>
                <ng-container *ngIf="row.isSeasonPassOrder">Entradas de tu abono · </ng-container>
                Comprado el {{ row.purchasedOn }}
            </p>
            <div class="row-divider" aria-hidden="true"></div>

            <div class="row-amount">
                <p class="m-0 amount">{{ row.total | currency: 'EUR' }}</p>
                <!-- Las que valen, como en el banner; si se devolvió una parte,
                     cuántas al lado. El importe es lo que se pagó por todas. -->
                <p class="m-0 quantity" *ngIf="!row.partiallyRefunded">{{ row.quantity }} {{ row.quantity === 1 ? 'entrada' : 'entradas' }}</p>
                <p class="m-0 quantity" *ngIf="row.partiallyRefunded">
                    {{ entradasVigentes(row) }} {{ entradasVigentes(row) === 1 ? 'entrada' : 'entradas' }}
                    <span class="quantity-devueltas">· {{ row.refundedCount }} {{ row.refundedCount === 1 ? 'devuelta' : 'devueltas' }}</span>
                </p>
            </div>

            <!-- Una entrada devuelta no se abre: no hay QR que enseñar ni PDF
                 que descargar. Y se dice por qué, que "No disponible" dejaba
                 al usuario sin saber qué había pasado. -->
            <span class="row-unavailable" *ngIf="row.refunded">
                <i class="fa-light fa-arrow-rotate-left"></i>
                {{ row.quantity === 1 ? 'Entrada devuelta' : 'Entradas devueltas' }}
            </span>
            <button type="button" class="btn-row" *ngIf="!row.refunded" (click)="openTickets(row)">
                <i class="fa-light fa-qrcode"></i>
                Ver entradas
            </button>
        </article>

        <!-- Vacío -->
        <div class="empty-state" *ngIf="!loadingPage && rows.length === 0">
            <i class="fa-light fa-ticket"></i>
            <p class="m-0 empty-title" *ngIf="scope === 'upcoming'">No tienes entradas para próximos eventos</p>
            <p class="m-0 empty-title" *ngIf="scope === 'past'">No hay entradas de eventos pasados</p>
            <p class="m-0 empty-text" *ngIf="search || activeFiltersCount > 0">Prueba a quitar el buscador o los filtros.</p>
            <a class="btn-primary" routerLink="/" *ngIf="!search && activeFiltersCount === 0 && scope === 'upcoming'">Descubrir planes</a>
        </div>
    </div>

    <div class="loading-container" *ngIf="loadingPage">
        <ng-lottie class="lottie" [options]="loadingLottie" containerClass="loading-box"></ng-lottie>
    </div>
</div>
